import { AddRounded } from "@mui/icons-material";
import { Button, Stack } from "@mui/material";
import { useCallback, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { GlobalContext } from "../../../../../../util/state/GlobalContextProvider";
import { BookingScope } from "../../../../types";
import { hasScope } from "../../../../utils";

const ToolbarActions = () => {

    const { globalData } = useContext(GlobalContext);

    const { t } = useTranslation('booking');

    const navigate = useNavigate();

    const handleClickNewRule = useCallback(() => {
        navigate('/booking/rules/insert');
    }, []);

    return (
        <Stack
            direction="row"
            alignItems="center"
            justifyContent="end"
            columnGap={2}
            px={2}
            py={1}
        >
            {hasScope(globalData, BookingScope.CreateEditRule) &&
                <Button startIcon={<AddRounded />} onClick={handleClickNewRule}>
                    {t('label.newRule')}
                </Button>
            }
        </Stack>
    );
};

export default ToolbarActions;